import { render, staticRenderFns } from "./CompraDadosBasicosTimeline.vue?vue&type=template&id=719c53a7&scoped=true"
import script from "./CompraDadosBasicosTimeline.vue?vue&type=script&lang=js"
export * from "./CompraDadosBasicosTimeline.vue?vue&type=script&lang=js"
import style0 from "./CompraDadosBasicosTimeline.vue?vue&type=style&index=0&id=719c53a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719c53a7",
  null
  
)

export default component.exports